import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import beautify from 'xml-beautifier';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-wbhidco',
  templateUrl: './wbhidco.component.html',
  styleUrls: ['./wbhidco.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class WbhidcoComponent implements OnInit {
  pageSize = 50;
  pageSizeOptions: number[]
  storeUserID: any
  apiresult: any;
  statusResult: string;
  requestPayload: any;
  storeOptionData = "LOG";
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  public idsProductList: idsProductList[];
  dataSource: MatTableDataSource<idsProductList>;
  // dataSource: any = [];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  requestPayloadReprocess: any;
  XMLName: string;
  defaultData: any;
  display: boolean;
  displayContentReprocess: boolean = false;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe) {

  }

  selected: string;
  selectedItems: any;
  Source: string;
  Userid: any = [];
  public User: string;
  rateCode: string;
  property: string;
  SourceBy: string;
  today = new Date();
  today1 = new Date();
  today2 = new Date();
  selectedDate: any = new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate() - 1));
  selectedDateReport: any = new Date(this.today2.setDate(this.today2.getDate()));
  selectedTOODateReport: any = new Date(this.today2.setDate(this.today2.getDate()));
  isProgressing: Boolean = false;
  Pmscodevalue: any;
  displayedColumns: string[] = ['Status', 'Hotel', 'CreateDate', 'Accounting_date', 'Updated_date', 'ProdCode', 'ModuleType', 'Response', 'Request'];
  displayedColumnsReprocess: string[] = ['statusremarks', 'statusflag', 'Hotel', 'Accounting_date', 'NewAccounting_date', 'pmsrequesttime'];
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any

  ngOnInit() {
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.SourceBy = "LOG";
    this.statusResult = "Not Sent"
    this.Source = "P";

    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.storeUserID = localStorage.getItem("Username");
    console.log('this.storeUserID', this.storeUserID)
    this.apiCallIdsService.getWBHIDCOGetProperties()
      .subscribe(
        data => {
          console.log('New Screen Data', data)

          this.apiresult = data;
          console.log('this.SourceBy =', this.SourceBy)
          if (this.SourceBy == 'LOG') {
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });
          }

          this.dropdownDeptData = this.apiresult
          if (this.SourceBy == 'LOG') {
            this.selectedDeptItems = this.getDimensionsByFilter("All");
            console.log('this.StoreValuetest', this.selectedDeptItems[0].propertyCode);
            this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
            console.log('this.Pmscodevalue =', this.Pmscodevalue)
          }
          this.isProgressing = false;
        });
  }

  getDimensionsByFilter(propertyCode: any) {
    console.log('dropdownDeptData =', this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  changeOption(data: any) {
    console.log("changeOption Value--->" + data);
    this.storeOptionData = data
    if (data == 'Re-process') {
      this.statusResult = ""
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    } else {
      this.statusResult = "Not Sent"
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    }
  }

  WBHIDCOLoad() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    this.selectedDateReport = this.datePipe.transform(this.selectedDateReport, 'yyyy-MM-dd');
    this.selectedTOODateReport = this.datePipe.transform(this.selectedTOODateReport, 'yyyy-MM-dd');
    if ((this.selectedTOODate < this.selectedDate) && this.storeOptionData == 'Re-process') {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    } 
    else if((this.selectedTOODateReport < this.selectedDateReport) && this.storeOptionData != 'Re-process'){
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    }
    else {
      if (this.storeOptionData == 'Re-process') {
        this.requestPayloadReprocess = {
          "PMSCODE": this.Pmscodevalue,
          "FRMDATE": this.selectedDate,
          "TOODATE": this.selectedTOODate
        }

        console.log('Re-process Payload =', this.requestPayloadReprocess)
        this.apiCallIdsService.getReprocessWBHIDCOlog(this.requestPayloadReprocess)
          .subscribe(
            data => {
              console.log('Data =', data[0])
              
              if (data[0].description == 'Already exists') {
                console.log('if condition')
                this.displayContentReprocess = false
                this.displayContent = false
                this.errorMsgSubscription = false
                this.errorMessage = "No Data Found"
                this.toastr.info(data[0].message);
                this.isProgressing = false;
              } else {
                console.log('else condition')
                console.log('Log Data = ', data);
                this.errorMsgSubscription = false
                this.displayContentReprocess = true
                this.displayContent = false
                this.idsProductList = data;
              this.dataSource = new MatTableDataSource(this.idsProductList);
              this.dataSource.paginator = this.paginator;
                this.toastr.success('Data loaded Successfully');
                this.isProgressing = false;
              }
            });
      } else {
        this.requestPayload = {
          "PMSCODE": this.Pmscodevalue,
          "FRMDATE": this.selectedDateReport,
          "TOODATE": this.selectedTOODateReport,
          "STATUS": this.statusResult,
        }

        console.log('Report Payload=', this.requestPayload)
        this.apiCallIdsService.getWBHIDCOlog(this.requestPayload)
          .subscribe(
            data => {
              console.log('Data =', data)
              this.idsProductList = data;
              this.dataSource = new MatTableDataSource(this.idsProductList);
              this.dataSource.paginator = this.paginator;
              if (data.length > 0) {
                console.log('Log Data = ', data);
                this.errorMsgSubscription = false
                this.displayContent = true
                this.displayContentReprocess = false
                this.toastr.success('Successfully Inserted');
                this.isProgressing = false;
              } else {
                this.displayContent = false
                this.displayContentReprocess = false
                this.errorMsgSubscription = true
                this.errorMessage = "No Data Found"
                this.toastr.error('No Data Found');
                this.isProgressing = false;
              }
            });
      }

    }

  }

  LoadXML(token: any, xmltype: any) {
    this.isProgressing = true;
    console.log('token', token);
    console.log('xmltype', xmltype);
    this.apiCallIdsService.WBHIDCOJSON(token, xmltype)
      .subscribe(data => {
        if (data.length < 1) {
          this.toastr.error('No data to load');
        } else {
          const xml = beautify(data[0].jsonData);
          console.log(xml);
          if (xmltype == 'Request') {
            this.XMLName = "Request JSON"
          } else {
            this.XMLName = "Response JSON"
          }
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }

  pageEvent(e: any) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
}
